/**
 * @ignore
 */
export class ClockInControls{
    operatorLock: boolean = false;
    manufacturingOrderLock: boolean = false;
    operationLock: boolean = false;
    currentTab: string = 'auto';
    of1: string = 'Maintenance';
    of2: string = 'Sodeca';
    of3: string = 'Various';

    constructor(){
        
    }
}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/clok-in-controls.ts